<div
  class="tw-bg-cover tw-bg-center tw-min-h-screen tw-pt-10"
  style="background-image: url('assets/images/background.png')"
>
  <div
    class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center md:tw-justify-between tw-w-[90%] sm:tw-w-[80%] tw-mx-auto tw-min-h-[80vh] tw-gap-10"
  >
    <!-- Texto: ahora primero en móvil -->
    <div
      class="tw-order-1 md:tw-order-1 tw-flex tw-flex-col tw-items-center md:tw-items-start tw-justify-center tw-px-4 sm:tw-px-6 tw-text-center md:tw-text-left tw-text-"
    >
      <h3
        class="tw-text-4xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-7xl tw-font-montserrat tw-font-black tw-text-white"
      >
        MI INTERNET
      </h3>
      <h3
        class="tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-7xl tw-font-montserrat tw-font-bold tw-text-white"
      >
        ES <span class="tw-text-[#F67011] tw-font-extrabold">ONELINK</span>
      </h3>
    </div>

    <div
      class="tw-px-2 tw-order-1 md:tw-order-2 relative tw-mt-8 md:tw-mt-0 tw-flex tw-justify-center"
    >
      <img
        src="assets/icons/ISOLOGO.svg"
        alt="Logo de la empresa"
        class="tw-h-52 tw-w-36 sm:tw-h-36 sm:tw-w-36 md:tw-h-48 md:tw-w-48 lg:tw-h-60 lg:tw-w-60 xl:tw-h-72 xl:tw-w-72"
      />
      <img
        src="assets/elipsis/orange.svg"
        alt=""
        class="tw-absolute tw-right-[0px] tw-top-[250px] lg:tw-top-[-10px] lg:tw-right-[10px] tw-opacity-35 tw-blur-md"
      />
      <img
        src="assets/elipsis/blue.svg"
        alt=""
        class="tw-absolute tw-top-[250px] tw-right-[0px] lg:tw-top-[-10px] lg:right-[10px] tw-opacity-35 tw-blur-md"
      />
    </div>
  </div>

  <!-- Texto inferior -->
  <div class="tw-flex tw-items-center tw-mt-6 tw-justify-center">
    <h4
      class="tw-text-sm sm:tw-text-base md:tw-text-lg lg:tw-text-xl xl:tw-text-2xl 2xl:tw-text-3xl tw-font-montserrat tw-font-bold tw-text-white text-center"
    >
      Habilitación CONATEL N° HGTS-00544
    </h4>
  </div>
</div>
